export const productHardware: string[] = [
  'Alpha 40',
  'Alpha 41',
  'Alpha 42',
  'Alpha 60',
  'Alpha 65',
  'Alpha 70',
  'Alpha 75',
  'Alpha 60 V2',
  'Alpha 65 V2',
  'Alpha 70 V2',
  'Alpha 75 V2',
];
